
// import lib
import validHelper from '../lib/validHelper';
import isEmpty from '../lib/isEmpty';

export const loginValid = (reqBody) => {
    let validDoc = {
        email: { type: 'string', required: true, regex: 'email' },
        password: { type: 'string', required: true },
        // rememberMe: { type: 'boolean', required: true }
    };
    return validHelper(validDoc, reqBody)
}